import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

/**
 * DataDog RUM (Real User Monitoring) Configuration
 * Only initializes if VITE_DD_CLIENT_TOKEN and VITE_DD_APPLICATION_ID are provided
 */

interface DataDogConfig {
  applicationId?: string
  clientToken?: string
}

/**
 * Loads DataDog configuration from environment variables
 */
const getDataDogConfig = (): DataDogConfig => {
  return {
    applicationId: import.meta.env.VITE_DD_APPLICATION_ID as string | undefined,
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN as string | undefined,
  }
}

/**
 * Initializes DataDog RUM if client token is provided
 * Returns true if initialization was successful, false otherwise
 */
export const initializeDataDog = (): boolean => {
  const config = getDataDogConfig()

  // Only initialize if client token is provided
  if (!config.clientToken) {
    // Client token not provided, skipping initialization
    return false
  }

  // Application ID is required for DataDog RUM
  if (!config.applicationId) {
    // Application ID not provided, skipping initialization
    return false
  }

  try {
    datadogRum.init({
      applicationId: config.applicationId,
      clientToken: config.clientToken,
      site: 'datadoghq.eu',
      service: 'eb-hub',
      env: 'production',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin()],
      proxy: 'https://datadog.enter.de/dd',
    })

    return true
  } catch (error) {
    console.error('DataDog: Failed to initialize', error)
    return false
  }
}

/**
 * Export DataDog RUM instance for custom logging
 */
export { datadogRum }
